import React, { useEffect } from 'react';
import logoFTD from '../../assets/image/logoFTD.svg';
import logoMarista from '../../assets/image/logo-marista.svg';
import logoCDMI from '../../assets/image/logo-cdmi.png';
import { maristaCredits,
  cdmiCredits,
  ftdCredits,
  additonalInfo,
  disclaimer } from '../../data/credits';
import Image from '../../components/image';
import BackToHomePageButton from '../../components/back-to-home-page-button';
import { Container, Footer, Wrapper, CreditsList, AdditionalInfoContainer } from './style';

function Credits() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      <BackToHomePageButton />
      <Wrapper>
        <h1>
          Expediente
        </h1>
        <div>
          <Image
            src={logoMarista}
            texto_alternativo="Logo do Grupo Marista em azul"
            width={192}
          />
          <CreditsList>
            {maristaCredits.map((entry) => (
              <li key={JSON.stringify(entry)}>
                <h3>{entry.role}</h3>
                <p>{entry.names}</p>
              </li>
          ))}
          </CreditsList>
        </div>
        <div>
          <Image
            src={logoCDMI}
            texto_alternativo="Logo do Centro de Defesa Marista de Infância em azul"
            width={240}
          />
          <CreditsList>
            {cdmiCredits.map((entry) => (
              <li key={JSON.stringify(entry)}>
                <h3>{entry.role}</h3>
                <p>{entry.names}</p>
              </li>
            ))}
          </CreditsList>
          <AdditionalInfoContainer>
            {additonalInfo}
          </AdditionalInfoContainer>
        </div>
        <div>
          <Image
            src={logoFTD}
            texto_alternativo="Logo da FTD Educação em azul"
            width={84}
          />
          <CreditsList>
            {ftdCredits.map((entry) => (
              <li key={JSON.stringify(entry)}>
                <h3>{entry.role}</h3>
                <p>{entry.names}</p>
              </li>
            ))}
          </CreditsList>
        </div>
        <div>
          <Footer>
            <div className="disclaimer">{disclaimer}</div>

            <small>
              ©
              {' '}
              <em>Copyright</em>
              {' '}
              2024 – Centro Marista de Defesa da Infância – Todos os direitos reservados.
            </small>
          </Footer>
        </div>
      </Wrapper>
    </Container>
  );
}

export default Credits;
